import { IraUser, User } from 'services/requests';

export const checkUser = (user: any): user is User => 'id' in user;

export const checkIraUser = (user: any): user is IraUser => !('isControlPerson' in user);
